import React from 'react'
import { TextInput, Switch } from '../../AlternateForm/WebInputs'

export default props => {
  return <>
    <TextInput label='System Name' name='name' />
    <Switch label='Frequently Audited' name='important' />
  </>
}
